import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
// 密钥对生成 http://web.chacuo.net/netrsakeypair
const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAy2wzr9hgBneFqr7dS1/ufPhGqOa27a9kBtFeJ+S2lfaxHozZCOZ/faMNt11S4MyrPQ+C7ze+k+X5c0QdY68vRsmPpBrG4kg4wFXAqqyJVMGBeb4iDtTamRbnUxUaqmFSNqozWlNvoy4A3P0R0mLTXeZiklUy8YhR8cqFqy0VK1+l+OOqv6sWKnOTFj9n3oMEjcMuAD3YqU0JphqQWUVtA9ZlEpYXZda6B0hO4aBHRdhjLGW4Sx5xvevoQrsIhFU4pI152q1wBu53v7Tm6NO/7fPS8iHk9XS2dZNc84/MuSmvRrGQ4ZhRecVirCjs6kqHy1w51ELn93kxwGg0uO7APQIDAQAB';

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}